import { api, queryString } from './client.ts';
import type {
  DispatchProposal,
  DispatchProposalsResult,
  DispatchReservationView,
  DispatchWeights,
} from '../../shared/dispatch.ts';

export type { DispatchProposalsResult, DispatchReservationView };

/** Auto-scheduling around labor availability. See docs/features/dispatch-auto-scheduling.md. */
export const dispatchApi = {
  settings: () => api.getFresh<{ revision: number; weights: DispatchWeights }>('/schedule/dispatch/settings'),
  saveSettings: (body: { revision: number; weights: DispatchWeights }) =>
    api.put<{ revision: number; weights: DispatchWeights }>('/schedule/dispatch/settings', body),
  proposals: (quoteId: string, from?: string, frequency?: string, firstCleanOptionId?: string) =>
    api.getFresh<DispatchProposalsResult>(
      `/schedule/dispatch/quotes/${quoteId}/proposals${queryString({
        ...(from ? { from } : {}),
        ...(frequency ? { frequency } : {}),
        ...(firstCleanOptionId ? { firstCleanOptionId } : {}),
      })}`,
    ),
  reserve: (seriesId: string, userId: string) =>
    api.post<{ reserved: number; startsOn: string }>(`/schedule/dispatch/series/${seriesId}/reservations`, {
      userId,
    }),
  reservations: (params: { from: string; to: string; userId?: string; conflictsOnly?: boolean }) =>
    api.getFresh<{ timezone: string; items: DispatchReservationView[]; conflicts: number }>(
      `/schedule/dispatch/reservations${queryString({
        from: params.from,
        to: params.to,
        ...(params.userId ? { userId: params.userId } : {}),
        ...(params.conflictsOnly ? { conflictsOnly: 'true' } : {}),
      })}`,
    ),
};

export type { DispatchProposal };
